export const facelivenessText = {
    // HintDisplayText
    hintMoveFaceFrontOfCameraText: 'Mueve tu rostro frente a la cámara',
    hintTooManyFacesText: 'Asegúrate de que solo haya un rostro frente a la cámara',
    hintFaceDetectedText: 'Rostro detectado',
    hintCanNotIdentifyText: 'Mueve tu rostro frente a la cámara',
    hintTooCloseText: 'Aléjate',
    hintTooFarText: 'Acércate',
    hintConnectingText: 'Conectando...',
    hintVerifyingText: 'Verificando...',
    hintCheckCompleteText: 'Verificación completada',
    hintIlluminationTooBrightText: 'Muévete a un área con menos luz',
    hintIlluminationTooDarkText: 'Muévete a un área con más luz',
    hintIlluminationNormalText: 'Condiciones de iluminación normales',
    hintHoldFaceForFreshnessText: 'Mantente quieto',
    hintCenterFaceText: 'Centra tu rostro',
    hintCenterFaceInstructionText: 'Instrucción: Antes de comenzar la verificación, asegúrate de que tu cámara esté en la parte superior central de tu pantalla y centra tu rostro frente a la cámara. Cuando comience la verificación, aparecerá un óvalo en el centro. Se te pedirá que te muevas hacia adelante dentro del óvalo y luego que te mantengas quieto. Después de mantenerte quieto durante unos segundos, deberías escuchar que la verificación está completa.',
    hintFaceOffCenterText: 'El rostro no está en el óvalo, centra tu rostro frente a la cámara.',
    hintMatchIndicatorText: '50% completado. Sigue acercándote.',

    // CameraDisplayText
    cameraMinSpecificationsHeadingText: 'La cámara no cumple con las especificaciones mínimas',
    cameraMinSpecificationsMessageText: 'La cámara debe soportar al menos una resolución de 320*240 y 15 cuadros por segundo.',
    cameraNotFoundHeadingText: 'La cámara no es accesible.',
    cameraNotFoundMessageText: 'Verifica que una cámara esté conectada y que no haya otra aplicación usando la cámara. Es posible que tengas que ir a la configuración para otorgar permisos de cámara y cerrar todas las instancias de tu navegador e intentar de nuevo.',
    retryCameraPermissionsText: 'Reintentar',
    waitingCameraPermissionText: 'Esperando que permitas el acceso a la cámara.',
    a11yVideoLabelText: 'Cámara web para verificación de vitalidad',

    // InstructionDisplayText
    goodFitCaptionText: 'Ajuste correcto',
    goodFitAltText: 'Ilustración del rostro de una persona, encajando perfectamente dentro de un óvalo.',
    photosensitivityWarningBodyText: 'Esta verificación muestra diferentes colores. Ten precaución si eres fotosensible.',
    photosensitivityWarningHeadingText: 'Advertencia de fotosensibilidad',
    photosensitivityWarningInfoText: 'Algunas personas pueden experimentar convulsiones epilépticas cuando se exponen a luces de colores. Ten precaución si tú o alguien en tu familia tiene una condición epiléptica.',
    photosensitivityWarningLabelText: 'Más información sobre fotosensibilidad',
    startScreenBeginCheckText: 'Iniciar verificación de video',
    tooFarCaptionText: 'Demasiado lejos',
    tooFarAltText: 'Ilustración del rostro de una persona dentro de un óvalo; hay un espacio entre el perímetro del rostro y los límites del óvalo.',

    // StreamDisplayText
    recordingIndicatorText: 'Grabando',
    cancelLivenessCheckText: 'Cancelar verificación de vitalidad',

    // ErrorDisplayText
    errorLabelText: 'Error',
    connectionTimeoutHeaderText: 'Tiempo de conexión agotado',
    connectionTimeoutMessageText: 'La conexión ha excedido el tiempo límite.',
    timeoutHeaderText: 'Tiempo agotado',
    timeoutMessageText: 'El rostro no encajó dentro del óvalo en el tiempo límite. Intenta de nuevo y llena completamente el óvalo con tu rostro.',
    faceDistanceHeaderText: 'Movimiento hacia adelante detectado',
    faceDistanceMessageText: 'Evita acercarte cuando te estés conectando.',
    multipleFacesHeaderText: 'Múltiples rostros detectados',
    multipleFacesMessageText: 'Asegúrate de que solo haya un rostro presente frente a la cámara al conectarte.',
    clientHeaderText: 'Error del cliente',
    clientMessageText: 'La verificación falló debido a un problema del cliente',
    serverHeaderText: 'Problema del servidor',
    serverMessageText: 'No se puede completar la verificación debido a un problema del servidor',
    landscapeHeaderText: 'La orientación horizontal no es compatible',
    landscapeMessageText: 'Rota tu dispositivo a orientación vertical (portrait).',
    portraitMessageText: 'Asegúrate de que tu dispositivo permanezca en orientación vertical (portrait) durante toda la verificación.',
    tryAgainText: 'Intentar de nuevo',
};
